export default __webpack_public_path__ + "static/media/360.06fa1ab0.svg";